module.exports = __webpack_public_path__ + "static/img/30007 (4).fbc5962.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30007 (4).webp
// module id = T411
// module chunks = 14